import { render, staticRenderFns } from "./AIAssistant.vue?vue&type=template&id=00a4a094&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"
import style0 from "./AIAssistant.vue?vue&type=style&index=0&id=00a4a094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4a094",
  null
  
)

export default component.exports